import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import * as types from 'application/_types/types.type';
import { getPinsDict } from 'application/routes/config/utils/tempsUtils';
const pinItems = getPinsDict();

interface PinListItemProps {
  disposition: types.StageDispositionPartial;
  isSelected: boolean;
}

const StyledPinBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '20px',
  backgroundColor: theme.custom?.isDark ? '#1E1E1E' : '#FFFFFF',
  justifyContent: 'space-between',
  border: `${isSelected ? '2px' : '1px'} solid ${
    isSelected ? theme.custom?.secondary : theme.custom?.stroke
  }`,
  borderRadius: '16px',
  cursor: 'pointer',
}));

const PinListItem: React.FC<PinListItemProps> = ({
  disposition,
  isSelected,
}) => {
  return (
    <StyledPinBox isSelected={isSelected}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <svg
          onClick={(e) => {
            e.stopPropagation();
            console.log(disposition.iconName);
            console.log(
              pinItems[disposition.iconName as keyof typeof pinItems]
            );
          }}
          width="13"
          height="6"
          viewBox="0 0 13 6"
          fill="none"
        >
          <path
            d="M0.875 2H12.125C12.2908 2 12.4497 1.89464 12.5669 1.70711C12.6842 1.51957 12.75 1.26522 12.75 1C12.75 0.734784 12.6842 0.48043 12.5669 0.292893C12.4497 0.105357 12.2908 0 12.125 0H0.875C0.70924 0 0.550268 0.105357 0.433058 0.292893C0.315848 0.48043 0.25 0.734784 0.25 1C0.25 1.26522 0.315848 1.51957 0.433058 1.70711C0.550268 1.89464 0.70924 2 0.875 2ZM12.125 4H0.875C0.70924 4 0.550268 4.10536 0.433058 4.29289C0.315848 4.48043 0.25 4.73478 0.25 5C0.25 5.26522 0.315848 5.51957 0.433058 5.70711C0.550268 5.89464 0.70924 6 0.875 6H12.125C12.2908 6 12.4497 5.89464 12.5669 5.70711C12.6842 5.51957 12.75 5.26522 12.75 5C12.75 4.73478 12.6842 4.48043 12.5669 4.29289C12.4497 4.10536 12.2908 4 12.125 4Z"
            fill="#A2ABB1"
          />
        </svg>
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '4px',
            overflow: 'hidden',
            p: 0,
          }}
        >
          <img
            className="pin-icon"
            style={{
              width: '48px',
              height: '48px',
              // padding: 5,
              // borderRadius: '4px',
              cursor: 'pointer',
              overflow: 'hidden',
            }}
            src={pinItems[disposition.iconName as keyof typeof pinItems]}
            alt={disposition.iconName}
            //   onClick={() => selectIcon(iconName)}
          />
        </Box>
        <Typography
          sx={(theme) => ({
            fontSize: 16,
            fontWeight: 600,
            color: theme.custom?.text,
          })}
        >
          {disposition.title || 'Untitled Pin'}
        </Typography>
      </Box>
      {disposition.isDefault && (
        <Box
          sx={(theme) => ({
            padding: '2px 4px',
            backgroundColor: theme.custom?.background3,
            borderRadius: '4px',
          })}
        >
          <Typography
            sx={(theme) => ({
              fontSize: 12,
              fontWeight: 600,
              color: theme.custom?.textLight,
            })}
          >
            Default Pin
          </Typography>
        </Box>
      )}
    </StyledPinBox>
  );
};

export default PinListItem;
